<template>
  <div class="hp-page">
    <aside class="hp-sidebar">
      <div class="side-top">
        <div class="flag-box">
          <span class="flag-red"></span>
          <span class="flag-arrow"></span>
        </div>
        <div class="balance">
          <span class="coin-mark"></span>
          <strong>700</strong>
        </div>
      </div>

      <div class="sound-row">
        <span class="sound-icon">‹</span>
        <div class="sound-track"><span></span></div>
        <span class="sound-icon">›</span>
      </div>

      <div class="brand-block" @click="goPath('/Index')">
        <img src="../assets/pizzaking/dynamic-logo-mark.png" alt="" />
        <strong>PizzaKing<span>-CJ</span></strong>
      </div>

      <div class="login-title">登录</div>
      <button class="steam-button" @click="$store.commit('getLogin', true)">
        STEAM
        <span class="steam-disc"></span>
      </button>

      <div class="social-row">
        <button>D</button>
        <button>T</button>
        <button>X</button>
        <button>G</button>
      </div>

      <button class="side-link partner" @click="goPath('/Spread')">
        <span class="side-link-icon"></span>
        合作伙伴计划
      </button>
      <button class="side-link welfare" @click="goPath('/activity')">
        <span class="side-link-icon"></span>
        福利箱子
      </button>

      <div class="free-case-card">
        <div class="free-case-img">
          <img :src="freeCaseImg" alt="" />
        </div>
        <div class="free-case-meta">
          <strong>66.22</strong>
          <span>Specialist Gloves<br />Buckshot</span>
          <button>加入</button>
        </div>
        <em>免费开启</em>
        <small>剩余时间: 17h 37m</small>
      </div>

      <div class="bonus-card">
        <strong>立即获得 10% 的奖金!</strong>
      </div>
    </aside>

    <main class="hp-main">
      <section class="live-strip">
        <div
          v-for="drop in liveDrops"
          :key="drop.name"
          class="live-drop"
        >
          <span class="live-star" v-if="drop.star"></span>
          <img :src="drop.img" :data-fallback="drop.fallback" alt="" @error="replaceCaseImage" />
          <strong>{{ drop.price }}</strong>
        </div>
      </section>

      <section class="mode-strip">
        <button
          v-for="mode in modes"
          :key="mode.title"
          class="mode-button"
          :class="[{ active: mode.active, unavailable: !mode.available }, 'mode-' + mode.key]"
          @click="openMode(mode)"
        >
          <span
            class="mode-icon"
            :style="{
              WebkitMaskImage: 'url(' + mode.icon + ')',
              maskImage: 'url(' + mode.icon + ')',
            }"
          ></span>
          <span v-if="mode.badge || !mode.available" class="mode-badge">{{ mode.badge || "敬请期待" }}</span>
          <strong>{{ mode.title }}</strong>
        </button>
      </section>

      <section v-if="!openboxOnly" class="battle-strip">
        <div class="pvp-label">
          <span>创建战斗</span>
          <i></i>
        </div>
        <transition-group name="battle-card" tag="div" class="battle-list">
          <button
            v-for="battle in battleCards"
            :key="battle.id || battle.title"
            class="battle-card"
            @click="goBattle(battle)"
          >
            <div class="battle-top">
              <span>{{ battle.players }}</span>
              <div v-if="battle.playerAvatars && battle.playerAvatars.length" class="battle-player-row">
                <img
                  v-for="(player, playerIndex) in battle.playerAvatars"
                  :key="`${battle.id || battle.title}-player-${playerIndex}`"
                  :src="player.img"
                  :data-fallback="defaultAvatar"
                  :alt="player.name"
                  @error="replaceAvatar"
                />
                <i v-if="battle.playerAvatars.length > 1">VS</i>
              </div>
              <em>{{ battle.rounds }}</em>
            </div>
            <div class="battle-watch">
              观看
              <span></span>
            </div>
            <strong>{{ battle.price }}</strong>
            <div class="battle-mobile-meta">
              <span>{{ battle.rounds }}</span>
              <strong>{{ battle.price }}</strong>
            </div>
            <div class="battle-items">
              <div v-for="(item, itemIndex) in battle.items" :key="(item.image || item) + itemIndex" class="battle-item">
                <img :src="item.image || item" :data-fallback="battle.fallback" alt="" @error="replaceCaseImage" />
                <span v-if="item.count > 1">x{{ item.count }}</span>
              </div>
            </div>
          </button>
        </transition-group>
        <p v-if="!battleCards.length" class="battle-empty">
          暂无可观看对战
          <button type="button" @click="goPath('/Lucky')">前往创建</button>
        </p>
      </section>

      <section class="filter-strip">
        <label class="search-box">
          <span></span>
          <input v-model.trim="caseSearch" placeholder="搜索箱子名称" />
        </label>
        <div class="switch-filter">
          余额足够开启
          <button :class="{ active: onlyAffordable }" @click="onlyAffordable = !onlyAffordable">
            <span></span>
          </button>
        </div>
        <div class="price-filter">
          <span>选择价格</span>
          <strong>{{ formatCasePrice(priceMin) }}</strong>
          <div class="range-line">
            <span class="range-fill" :style="priceRangeStyle"></span>
            <input
              class="price-range-input price-range-min"
              type="range"
              min="0"
              :max="priceRangeMax"
              step="0.01"
              :value="priceMin"
              @input="setPriceMin"
            />
            <input
              class="price-range-input price-range-max"
              type="range"
              min="0"
              :max="priceRangeMax"
              step="0.01"
              :value="priceMax"
              @input="setPriceMax"
            />
          </div>
          <strong>{{ formatCasePrice(priceMax) }}</strong>
        </div>
        <button class="brush-button" @click="resetCaseFilters"></button>
      </section>

      <section class="category-grid">
        <button
          v-for="category in categories"
          :key="category"
          :class="{ active: activeCategory === category }"
          @click="activeCategory = category"
        >
          {{ categoryLabel(category) }}
        </button>
      </section>

      <p v-if="caseLoading" class="case-state">正在读取箱子列表</p>
      <p v-else-if="!visibleGroups.length" class="case-state">暂无可开启箱子</p>

      <section v-for="group in visibleGroups" :key="group.type_name" class="case-section">
        <h2>{{ categoryLabel(group.type_name) }}</h2>
        <div class="case-grid">
          <button
            v-for="item in group.box_list"
            :key="item.id"
            class="case-card"
            type="button"
            :aria-label="`查看 ${item.name} 详情`"
            @click="openbox(item.id)"
          >
            <span class="case-value">{{ item.value }}</span>
            <div class="case-image">
              <img
                v-if="item.effectImg"
                class="case-image-effect"
                :src="item.effectImg"
                :data-fallback="item.img"
                :alt="`${item.name} 特效`"
                @error="replaceCaseImage"
              />
              <img
                class="case-image-main"
                :src="item.img"
                :data-fallback="item.fallback"
                :alt="item.name"
                @error="replaceCaseImage"
              />
              <span class="case-open-overlay" aria-hidden="true">
                <b>开启</b>
                <i class="case-open-pizza"></i>
              </span>
              <span v-if="item.hasHiddenGold" class="case-hidden-gold" aria-label="包含金色传说">
                <img :src="hiddenGoldImage" alt="" />
              </span>
            </div>
            <strong>{{ item.name }}</strong>
            <em>{{ item.subtitle }}</em>
            <div class="case-price">
              {{ item.price }}
              <span></span>
            </div>
          </button>
        </div>
      </section>

      <footer class="pk-home-footer">
        <section class="pk-home-stats">
          <article>
            <span>累计打开箱子</span>
            <strong>{{ formatSiteStat(siteStats.openbox_num) }}</strong>
            <em>累计开启箱子</em>
          </article>
          <article>
            <span>注册玩家</span>
            <strong>{{ formatSiteStat(siteStats.player_num) }}</strong>
            <em>已注册玩家</em>
          </article>
          <article>
            <span>箱子战斗</span>
            <strong>{{ formatSiteStat(siteStats.battle_num) }}</strong>
            <em>累计箱子战斗</em>
          </article>
          <article>
            <span>今日在线</span>
            <strong>{{ formatSiteStat(siteStats.online_num) }}</strong>
            <em>今日在线人数</em>
          </article>
        </section>
        <section class="pk-home-footer-bottom">
          <button class="pk-footer-brand" type="button" aria-label="返回首页" @click="goPath('/Index')">
            <img src="../assets/pizzaking/dynamic-logo-mark.png" alt="" />
            <strong>PizzaKing<span>-CJ</span></strong>
          </button>
          <div class="pk-footer-copy">
            <div class="pk-footer-links">
              <button @click="goPath('/Abouts')">关于我们</button>
              <button @click="goPath('/Doubt')">联系我们</button>
              <button @click="goPath('/Doubt')">支持中心</button>
              <button @click="goPath('/Agreement')">用户协议</button>
              <button @click="goPath('/Privacy')">隐私政策</button>
              <button @click="goPath('/Clause')">退款政策</button>
            </div>
            <p>{{ siteContent.footer.description }}</p>
          </div>
          <small>{{ siteContent.footer.copyright }}</small>
          <div class="pk-footer-network-row">
            <FooterFriendLinks />
          </div>
        </section>
      </footer>
    </main>
  </div>
</template>

<script>
import { OPENBOX_ONLY_LAUNCH } from "@/config";
import { cloneSiteContent, loadSiteContent } from "@/services/siteContent";
import FooterFriendLinks from "@/components/FooterFriendLinks.vue";

export default {
  components: { FooterFriendLinks },
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    const casePurple = require("../assets/hotpizza/hp-case-purple-transparent.png");
    const caseCrystal = require("../assets/hotpizza/hp-case-crystal.png");
    const caseOrange = require("../assets/hotpizza/hp-case-orange.png");
    const caseGreen = require("../assets/hotpizza/hp-case-green.png");
    const caseBlue = require("../assets/hotpizza/hp-case-blue.png");
    const caseIce = require("../assets/hotpizza/hp-case-ice.png");
    const caseFire = require("../assets/hotpizza/hp-case-fire.png");
    const gloves = require("../assets/hotpizza/hp-gloves.png");
    const freeCase = "/img/pizzaking/columns/backpack.png";
    const iconOpenCase = require("../assets/pizzaking/mode-open-case.svg");
    const iconCheese = require("../assets/pizzaking/cheese-token.svg");
    const iconBattle = require("../assets/pizzaking/mode-battle.svg");
    return {
      openboxOnly: OPENBOX_ONLY_LAUNCH,
      siteContent: cloneSiteContent(),
      freeCaseImg: freeCase,
      defaultAvatar: require("../assets/img/jiapeople.png"),
      hiddenGoldImage: require("../assets/pizzaking/hidden-gold.png"),
      liveDrops: [],
      modes: [
        { key: "case", title: "打开箱子", path: "/zh", active: true, icon: iconOpenCase, available: true },
        { key: "cheese", title: "奶酪秘境", path: "/Cheese", active: false, icon: iconCheese, available: true },
        { key: "battle", title: "箱子战斗", path: "/zh/battles", badge: "敬请期待", icon: iconBattle, available: !OPENBOX_ONLY_LAUNCH },
      ],
      liveBattleCards: [],
      battleTimer: null,
      liveDropTimer: null,
      categories: ["全部"],
      cases: [],
      caseGroups: [],
      caseLoading: true,
      caseSearch: "",
      activeCategory: "全部",
      onlyAffordable: false,
      priceMin: 0,
      priceMax: 3000,
      siteStats: {
        openbox_num: 0,
        player_num: 0,
        battle_num: 0,
        online_num: 0,
      },
      siteStatsTimer: null,
      caseCountTimer: null,
      caseFallbacks: [casePurple, caseCrystal, caseOrange, caseGreen, caseBlue, caseIce, caseFire, gloves],
      categoryLabels: {
        "Baby Bus": "婴儿巴士",
        Carnival: "狂欢嘉年华",
        "High end zone": "高端专区",
        "sniper god": "狙击之神",
        "Close call": "险中求胜",
        "Dream Chasing": "追逐梦想",
      },
      skinFallbacks: [
        require("../assets/hotpizza/hp-mp9-red.png"),
        require("../assets/hotpizza/hp-m4-blue.png"),
        require("../assets/hotpizza/hp-awp-blue.png"),
        require("../assets/hotpizza/hp-ak-green.png"),
      ],
    };
  },
  computed: {
    priceRangeMax() {
      const prices = this.cases.map((box) => Number(box.price || 0));
      return Math.max(1, Math.ceil(Math.max(...prices) * 100) / 100);
    },
    priceRangeStyle() {
      const minPercent = (this.priceMin / this.priceRangeMax) * 100;
      const widthPercent = ((this.priceMax - this.priceMin) / this.priceRangeMax) * 100;
      return {
        left: minPercent + "%",
        width: widthPercent + "%",
      };
    },
    visibleGroups() {
      const sourceGroups = this.caseGroups;
      const keyword = this.caseSearch.toLowerCase();
      const balance = Number(this.$store.state.money || 0);

      return sourceGroups
        .filter((group) => this.activeCategory === "全部" || group.type_name === this.activeCategory)
        .map((group) => ({
          ...group,
          box_list: group.box_list.filter((box) => {
            const matchedKeyword = !keyword || box.name.toLowerCase().includes(keyword);
            const canAfford = !this.onlyAffordable || balance >= Number(box.price || 0);
            const isWithinPrice = Number(box.price || 0) >= this.priceMin && Number(box.price || 0) <= this.priceMax;
            return matchedKeyword && canAfford && isWithinPrice;
          }),
        }))
        .filter((group) => group.box_list.length);
    },
    battleCards() {
      return this.liveBattleCards;
    },
  },
  mounted() {
    this.loadCases();
    this.loadLiveDrops();
    this.loadSiteStats();
    loadSiteContent(this.$axios).then((content) => {
      this.siteContent = content;
    });
    if (!this.openboxOnly) {
      this.loadBattles();
      this.battleTimer = window.setInterval(this.loadBattles, 15000);
    }
    this.siteStatsTimer = window.setInterval(this.loadSiteStats, 60000);
    this.caseCountTimer = window.setInterval(this.refreshCaseOpenCounts, 5000);
    this.liveDropTimer = window.setInterval(this.loadLiveDrops, 15000);
    this.$root.$on("box-count-refresh", this.refreshCaseOpenCounts);
    this.$root.$on("online-count-update", this.updateOnlineCount);
    window.addEventListener("focus", this.refreshCaseOpenCounts);
    document.addEventListener("visibilitychange", this.handlePageVisible);
  },
  activated() {
    this.loadCases();
    this.refreshCaseOpenCounts();
  },
  beforeDestroy() {
    window.clearInterval(this.siteStatsTimer);
    window.clearInterval(this.caseCountTimer);
    window.clearInterval(this.battleTimer);
    window.clearInterval(this.liveDropTimer);
    this.$root.$off("box-count-refresh", this.refreshCaseOpenCounts);
    this.$root.$off("online-count-update", this.updateOnlineCount);
    window.removeEventListener("focus", this.refreshCaseOpenCounts);
    document.removeEventListener("visibilitychange", this.handlePageVisible);
  },
  methods: {
    updateOnlineCount(value) {
      this.$set(this.siteStats, "online_num", Number(value || 0));
    },
    normalizeAssetUrl(url) {
      return String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
    },
    caseImageUrl(url, fallback) {
      const image = this.normalizeAssetUrl(url);
      if (image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) {
        return fallback;
      }
      return image;
    },
    versionedAssetUrl(url, version) {
      const image = String(url || "");
      if (!image || image.indexOf("data:") === 0) return image;
      return image + (image.indexOf("?") === -1 ? "?" : "&") + "v=" + encodeURIComponent(version || "1");
    },
    handlePageVisible() {
      if (document.visibilityState === "visible") {
        this.loadCases();
        this.refreshCaseOpenCounts();
      }
    },
    loadCases() {
      this.$axios.post("/index/Box/boxList", this.$qs.stringify({})).then((res) => {
        const groups = (res.data.data.list || []).map((group) => ({
          ...group,
          box_list: (group.box_list || []).filter((box) => (box.consume_currency || "pizza") !== "cheese"),
        })).filter((group) => group.box_list.length);
        let caseIndex = 0;
        this.caseGroups = groups.map((group) => ({
          ...group,
          box_list: group.box_list.map((box) => {
            const fallback = this.caseFallbacks[caseIndex % this.caseFallbacks.length];
            caseIndex += 1;
            return {
              id: box.id,
              value: String(box.open_count || 0),
              name: box.name,
              subtitle: group.type_name,
              price: String(box.price),
              img: this.caseImageUrl(this.versionedAssetUrl(box.img_main, box.update_time || box.id), fallback),
              effectImg: box.img_active ? this.caseImageUrl(this.versionedAssetUrl(box.img_active, box.update_time || box.id), "") : "",
              hasHiddenGold: Number(box.has_hidden_gold || 0) === 1,
              fallback,
            };
          }),
        }));
        this.categories = ["全部"].concat(groups.map((group) => group.type_name));
        this.cases = this.caseGroups.reduce((items, group) => items.concat(group.box_list), []);
        this.priceMin = 0;
        this.priceMax = this.priceRangeMax;
        this.caseLoading = false;
        this.refreshCaseOpenCounts();
      }).catch(() => {
        this.caseGroups = [];
        this.cases = [];
        this.categories = ["全部"];
        this.caseLoading = false;
      });
    },
    refreshCaseOpenCounts() {
      this.$axios.post("/index/Box/boxOpenCounts?_=" + Date.now(), this.$qs.stringify({})).then((res) => {
        const list = res.data && res.data.status == 1 && res.data.data ? res.data.data.list || [] : [];
        const counts = list.reduce((map, item) => {
          map[String(item.box_id)] = Number(item.open_count || 0);
          return map;
        }, {});
        this.caseGroups.forEach((group) => {
          group.box_list.forEach((box) => {
            this.$set(box, "value", String(counts[String(box.id)] || 0));
          });
        });
      });
    },
    loadLiveDrops() {
      this.$axios.post("/index/Box/latelynew", this.$qs.stringify({ page: 1, pageSize: 8 })).then((res) => {
        const list = res.data && res.data.status == 1 && res.data.data ? res.data.data.list || [] : [];
        this.liveDrops = list.map((item, index) => ({
          name: `${item.id || index}-${item.skin_name || item.name || "drop"}`,
          img: this.normalizeAssetUrl(item.imageUrl || item.img) || this.caseFallbacks[index % this.caseFallbacks.length],
          fallback: this.skinFallbacks[index % this.skinFallbacks.length],
          price: Number(item.price || 0).toFixed(2),
          star: Number(item.is_stattrak || item.stattrak || 0) === 1,
        }));
      }).catch(() => {
        this.liveDrops = [];
      });
    },
    loadSiteStats() {
      this.$axios.post("/index/Login/logininfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.siteStats = res.data.data;
        }
      });
    },
    loadBattles() {
      this.$axios.post("/index/Battle/battleList", this.$qs.stringify({ page: 1, pageSize: 8 })).then((res) => {
        if (res.data.status != 1 || !res.data.data || !res.data.data.battleList) {
          this.liveBattleCards = [];
          return;
        }
        this.liveBattleCards = res.data.data.battleList.map((battle, index) => {
          const boxes = battle.boxInfo || [];
          const fallback = this.caseFallbacks[index % this.caseFallbacks.length];
          const price = boxes.reduce((total, item) => total + Number(item.price || 0), 0).toFixed(2);
          const items = boxes.reduce((list, item) => {
            const image = this.caseImageUrl(item.img_active || item.img_main, fallback);
            const existing = list.find((entry) => entry.image === image);
            if (existing) {
              existing.count += 1;
            } else {
              list.push({ image, count: 1 });
            }
            return list;
          }, []);
          const players = (battle.player_info || []).filter((item) => item && item.id);
          const playerCount = players.length;
          return {
            id: battle.id,
            title: `battle-${battle.id}`,
            players: `玩家 ${playerCount}/${battle.mode || 2}`,
            rounds: battle.status == 3 ? "已结束" : `${boxes.length} 回合`,
            price,
            items: items.slice(0, 5),
            fallback,
            playerAvatars: players.slice(0, 4).map((player) => ({
              name: player.name || "玩家",
              img: this.normalizeAssetUrl(player.img || player.image) || this.defaultAvatar,
            })),
          };
        });
      }).catch(() => {
        this.liveBattleCards = [];
      });
    },
    goBattle(battle) {
      if (battle.id) {
        this.$router.push({ path: "/LuckyRoom", query: { id: battle.id } });
        return;
      }
      this.goPath("/Lucky");
    },
    formatSiteStat(value) {
      return Number(value || 0).toLocaleString("en-US");
    },
    categoryLabel(value) {
      return this.categoryLabels[value] || value;
    },
    resetCaseFilters() {
      this.caseSearch = "";
      this.activeCategory = "全部";
      this.onlyAffordable = false;
      this.priceMin = 0;
      this.priceMax = this.priceRangeMax;
    },
    formatCasePrice(value) {
      return Number(value || 0).toFixed(2).replace(/\.00$/, "");
    },
    setPriceMin(event) {
      this.priceMin = Math.min(Number(event.target.value), this.priceMax);
    },
    setPriceMax(event) {
      this.priceMax = Math.max(Number(event.target.value), this.priceMin);
    },
    replaceCaseImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    replaceAvatar(event) {
      event.target.src = event.target.dataset.fallback;
    },
    goPath(path) {
      this.$router.push({ path });
    },
    openMode(mode) {
      if (!mode.available) {
        this.$message.info(mode.key === "battle" ? "箱子战斗敬请期待" : "该玩法暂未开放");
        return;
      }
      this.goPath(mode.path);
    },
    openbox(box_id) {
      this.$router.push({
        path: "/Openbox",
        query: { box_id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hp-page {
  min-height: 100vh;
  overflow: visible;
  display: block;
  color: #d9deea;
  background: transparent;
  font-family: "Microsoft YaHei", sans-serif;
}

button {
  font-family: inherit;
}

.hp-sidebar {
  display: none;
  min-width: 250px;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  background: #171822;
  border-right: 1px solid #272937;
}

.side-top {
  height: 58px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 0 20px;
}

.flag-box {
  display: flex;
  align-items: center;
  gap: 15px;
}

.flag-red {
  width: 28px;
  height: 18px;
  display: block;
  background: #ff4052;
  position: relative;
}

.flag-red::after {
  content: "";
  width: 4px;
  height: 4px;
  position: absolute;
  left: 7px;
  top: 5px;
  background: #ffd96a;
  border-radius: 50%;
}

.flag-arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #5e6472;
}

.balance {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #f26943;
  font-size: 18px;
}

.coin-mark,
.case-price span {
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.sound-row {
  height: 56px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #242631;
  border-bottom: 1px solid #242631;
}

.sound-icon {
  color: #a8afbc;
  font-size: 20px;
  line-height: 1;
}

.sound-track {
  flex: 1;
  height: 10px;
  background: #484b5a;
  border-radius: 20px;
  position: relative;
}

.sound-track span {
  width: 14px;
  height: 14px;
  display: block;
  position: absolute;
  top: -2px;
  left: 52%;
  background: #edf1f3;
  border-radius: 50%;
}

.brand-block {
  height: 96px;
  padding: 18px 13px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.brand-block img {
  width: 68px;
  height: 68px;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(255, 100, 0, 0.18));
}

.brand-block strong {
  color: #fff7e6;
  font-size: 24px;
  font-weight: 950;
  transition: color 0.2s ease;
}

.brand-block:hover strong {
  color: #ffd266;
}

.brand-block strong span {
  margin-left: 0;
  color: #ff9d2e;
  font-size: 12px;
}

.login-title {
  margin: 6px 20px 12px;
  color: #626c7b;
  font-size: 14px;
}

.steam-button {
  width: calc(100% - 40px);
  height: 41px;
  margin: 0 20px 10px;
  color: #fff;
  background: #f26900;
  border: 0;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}

.steam-disc {
  width: 19px;
  height: 19px;
  margin-left: 8px;
  display: inline-block;
  vertical-align: middle;
  background: #fff;
  border-radius: 50%;
}

.social-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 0 20px 24px;
}

.social-row button {
  height: 36px;
  color: #a8afbc;
  background: #3b3e4d;
  border: 0;
  border-radius: 7px;
  font-size: 18px;
  font-weight: 900;
}

.side-link {
  width: calc(100% - 28px);
  height: 48px;
  margin: 0 14px 8px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  color: #8b96a8;
  background: #252834;
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 800;
  text-align: left;
  cursor: pointer;
}

.side-link-icon {
  width: 20px;
  height: 20px;
  display: block;
  border: 0;
  background: currentColor;
  -webkit-mask: center / contain no-repeat;
  mask: center / contain no-repeat;
}

.side-link.partner .side-link-icon {
  -webkit-mask-image: url("../assets/pizzaking/icon-partner.svg");
  mask-image: url("../assets/pizzaking/icon-partner.svg");
}

.side-link.welfare .side-link-icon {
  -webkit-mask-image: url("../assets/pizzaking/icon-welfare.svg");
  mask-image: url("../assets/pizzaking/icon-welfare.svg");
}

.free-case-card {
  min-height: 105px;
  margin: 28px 20px;
  position: relative;
  display: grid;
  grid-template-columns: 92px 1fr;
  overflow: hidden;
  background: #202330;
  border: 1px solid #ff7845;
  border-radius: 8px;
}

.free-case-img {
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(135deg, rgba(19, 28, 42, 0.88), rgba(145, 15, 71, 0.78)),
    url("../assets/img/banner22.png") center / cover;
}

.free-case-img img {
  width: 112px;
  height: 78px;
  object-fit: contain;
}

.free-case-meta {
  padding: 10px 8px;
  font-size: 11px;
}

.free-case-meta strong {
  color: #ff9b3d;
}

.free-case-meta span {
  display: block;
  color: #fff;
  font-weight: 800;
  line-height: 1.2;
}

.free-case-meta button {
  margin-top: 6px;
  padding: 5px 12px;
  color: #fff;
  background: #d8664b;
  border: 0;
  border-radius: 4px;
  font-weight: 900;
}

.free-case-card em {
  position: absolute;
  right: -8px;
  bottom: 29px;
  padding: 9px 18px;
  color: #fff;
  background: #bf0c5b;
  border-radius: 8px 0 0 8px;
  font-style: normal;
  font-size: 14px;
  font-weight: 900;
}

.free-case-card small {
  position: absolute;
  left: 10px;
  bottom: 8px;
  color: #e17365;
  font-size: 11px;
}

.bonus-card {
  height: 150px;
  margin: 0 10px 30px;
  display: flex;
  align-items: flex-end;
  padding: 16px;
  color: #fff;
  background:
    linear-gradient(140deg, rgba(220, 20, 30, 0.4), rgba(255, 111, 0, 0.18)),
    url("../assets/img/banner22.png") center / cover;
  border-radius: 8px;
  font-size: 24px;
  line-height: 1.15;
}

.hp-main {
  min-height: 100vh;
  overflow: visible;
  background: transparent;
}

.live-strip {
  display: none;
  height: 114px;
  display: grid;
  grid-template-columns: repeat(8, minmax(105px, 1fr));
  border-bottom: 1px solid #41305f;
}

.live-drop {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;
  isolation: isolate;
  background: linear-gradient(180deg, #151620, #181923);
  border-left: 1px solid #242637;
}

.live-drop::before {
  content: "";
  width: 116px;
  height: 82px;
  position: absolute;
  left: 50%;
  top: 5px;
  z-index: -1;
  background:
    radial-gradient(circle, var(--drop-glow, rgba(122, 54, 255, 0.75)) 0 12%, rgba(122, 54, 255, 0.42) 24%, transparent 66%),
    radial-gradient(circle at 70% 35%, rgba(255, 255, 255, 0.16), transparent 38%);
  filter: blur(1px);
  transform: translateX(-50%);
}

.live-drop::after {
  content: "";
  width: 150px;
  height: 56px;
  position: absolute;
  left: 50%;
  top: 16px;
  z-index: -1;
  background: linear-gradient(115deg, transparent 0 25%, rgba(255, 255, 255, 0.09) 48%, transparent 72%);
  opacity: 0.55;
  transform: translateX(-50%) rotate(-8deg);
}

.live-drop:nth-child(2) {
  --drop-glow: rgba(70, 89, 255, 0.72);
}

.live-drop:nth-child(3) {
  --drop-glow: rgba(29, 118, 255, 0.76);
}

.live-drop:nth-child(4) {
  --drop-glow: rgba(37, 180, 84, 0.72);
}

.live-drop:nth-child(5) {
  --drop-glow: rgba(255, 78, 33, 0.76);
}

.live-drop:nth-child(6) {
  --drop-glow: rgba(44, 207, 255, 0.72);
}

.live-drop:nth-child(7) {
  --drop-glow: rgba(190, 61, 255, 0.72);
}

.live-drop:nth-child(8) {
  --drop-glow: rgba(111, 64, 255, 0.82);
}

.live-drop img {
  width: 120px;
  height: 64px;
  position: relative;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 11px 18px rgba(0, 0, 0, 0.52));
}

.live-drop strong {
  color: #edb145;
  font-size: 13px;
}

.live-drop strong::after,
.battle-card strong::after {
  content: "";
  width: 12px;
  height: 12px;
  margin-left: 3px;
  display: inline-block;
  vertical-align: -1px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.live-star {
  position: absolute;
  top: 15px;
  right: 24px;
  width: 6px;
  height: 6px;
  background: #edb145;
  transform: rotate(45deg);
}

.mode-strip {
  display: none;
  height: 84px;
  display: grid;
  grid-template-columns: repeat(9, minmax(90px, 1fr));
  gap: 6px;
  padding: 0 0 0 12px;
  background: #20222f;
  border-bottom: 1px solid #272937;
}

.mode-button {
  position: relative;
  height: 73px;
  align-self: end;
  color: #8fa0ba;
  background: #252836;
  border: 0;
  border-radius: 0 0 8px 8px;
  cursor: pointer;
}

.mode-button.active {
  color: #ff8a27;
  background: #242733;
  border-bottom: 3px solid #ff8a27;
}

.mode-button.unavailable {
  opacity: 0.52;
  cursor: not-allowed;
  filter: saturate(0.35);
}

.mode-button.unavailable .mode-badge {
  right: 5px;
  padding: 3px 5px;
  color: #aeb5c5;
  background: #343746;
}

.mode-button.empty {
  color: #14d6e6;
}

.mode-button.mode-battle {
  color: #8f67ff;
  background: #2d2a58;
}

.mode-button.mode-cheese {
  color: #ffd45d;
  background: #3a3021;
}

.mode-icon {
  width: 28px;
  height: 28px;
  margin: 0 auto 7px;
  display: block;
  background: currentColor;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  filter: drop-shadow(0 0 8px currentColor);
}

.mode-button strong {
  display: block;
  font-size: 12px;
  font-weight: 900;
}

.mode-badge {
  position: absolute;
  right: 8px;
  top: 0;
  padding: 3px 9px;
  color: #42d7ff;
  background: #155270;
  font-size: 10px;
  font-weight: 900;
}

.battle-strip {
  box-sizing: border-box;
  height: 172px;
  min-height: 172px;
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  gap: 0;
  padding: 10px 14px 12px 18px;
  background: #20222f;
  border-top: 1px solid rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.pvp-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #f9edd1;
  background: linear-gradient(180deg, #292b38, #242633);
  border-radius: 8px 0 0 8px;
  font-size: 18px;
  font-weight: 900;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.45);
}

.pvp-label span {
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 2px;
  line-height: 1.15;
}

.pvp-label i {
  width: 16px;
  height: 16px;
  display: block;
  border-bottom: 2px solid #f9edd1;
  border-left: 2px solid #f9edd1;
  transform: rotate(-45deg);
}

.battle-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  min-height: 150px;
  overflow: hidden;
}

.battle-card {
  position: relative;
  min-width: 0;
  height: 150px;
  padding: 0;
  overflow: hidden;
  color: #cbd4e4;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0)),
    linear-gradient(180deg, #2d2f3d, #353744);
  border: 0;
  border-radius: 9px;
  box-shadow:
    inset 0 -72px 70px rgba(16, 17, 25, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);
  cursor: pointer;
  text-align: left;
}

.battle-top {
  position: absolute;
  z-index: 2;
  top: 6px;
  left: 26px;
  right: 26px;
  display: flex;
  justify-content: space-between;
  color: #c9cfda;
  font-size: 12px;
  line-height: 14px;
  font-weight: 900;
}

.battle-watch {
  position: absolute;
  z-index: 2;
  top: 20px;
  left: 50%;
  width: 98px;
  height: 32px;
  color: #fff5d0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #f4d9b1;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 900;
  transform: translateX(-50%);
}

.battle-watch span {
  width: 16px;
  height: 10px;
  border: 2px solid currentColor;
  border-radius: 50%;
}

.battle-card strong {
  position: absolute;
  z-index: 2;
  top: 20px;
  right: 26px;
  height: 32px;
  display: flex;
  align-items: center;
  color: #edb145;
  font-size: 16px;
  line-height: 1;
}

.battle-items {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 76px;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background: rgba(31, 33, 45, 0.7);
  border-top: 1px solid rgba(152, 159, 184, 0.18);
}

.battle-items img {
  box-sizing: border-box;
  width: 100%;
  height: 76px;
  object-fit: contain;
  object-position: center bottom;
  padding: 4px 14px 0;
  mix-blend-mode: screen;
  filter: drop-shadow(0 0 14px rgba(255, 146, 47, 0.22));
  border-left: 1px solid rgba(29, 31, 43, 0.95);
}

.battle-empty {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #9099ae;
  font-size: 13px;
  font-weight: 800;
}

.battle-empty button {
  height: 30px;
  padding: 0 12px;
  color: #f8dfb3;
  border: 1px solid rgba(248, 223, 179, 0.48);
  border-radius: 4px;
  background: #292c3a;
  font-weight: 900;
}

.case-state {
  width: calc(100% - 40px);
  max-width: 1580px;
  min-height: 150px;
  margin: 28px auto 0;
  display: grid;
  place-items: center;
  color: #939caf;
  border: 1px dashed rgba(255, 255, 255, 0.13);
  border-radius: 8px;
  background: #20222f;
  font-size: 14px;
  font-weight: 800;
}

.filter-strip {
  min-height: 68px;
  display: grid;
  grid-template-columns: minmax(240px, 272px) minmax(210px, auto) minmax(350px, 1fr) 42px;
  gap: 18px;
  align-items: center;
  padding: 12px 20px 8px;
  background: #20222f;
}

.search-box {
  height: 42px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  background: #1c1d29;
  border: 1px solid #444759;
  border-radius: 6px;
}

.search-box span {
  width: 14px;
  height: 14px;
  border: 2px solid #7e8798;
  border-radius: 50%;
  position: relative;
}

.search-box span::after {
  content: "";
  width: 7px;
  height: 2px;
  position: absolute;
  right: -6px;
  bottom: -4px;
  background: #7e8798;
  transform: rotate(45deg);
}

.search-box input {
  width: 100%;
  color: #edf1f3;
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 14px;
  font-weight: 800;
}

.switch-filter,
.price-filter {
  color: #cbd4e4;
  font-size: 14px;
  font-weight: 900;
}

.switch-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch-filter button {
  width: 34px;
  height: 20px;
  padding: 0;
  background: #e3e7ec;
  border: 0;
  border-radius: 20px;
}

.switch-filter span {
  width: 16px;
  height: 16px;
  display: block;
  margin-left: 2px;
  background: #808592;
  border-radius: 50%;
}

.switch-filter button.active {
  background: #ff9b1d;
}

.switch-filter button.active span {
  transform: translateX(14px);
}

.price-filter {
  display: grid;
  grid-template-columns: auto auto minmax(170px, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.price-filter strong {
  color: #edb145;
}

.range-line {
  height: 4px;
  background: #e5e8ee;
  border-radius: 10px;
  position: relative;
}

.range-line i {
  width: 16px;
  height: 16px;
  position: absolute;
  top: -6px;
  background: #fff;
  border-radius: 50%;
}

.range-line i:first-child {
  left: 0;
}

.range-line i:last-child {
  right: 0;
}

.brush-button {
  height: 40px;
  background: #2c2f3d;
  border: 0;
  border-radius: 7px;
  position: relative;
}

.brush-button::before {
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  left: 13px;
  top: 10px;
  border: 2px solid #7e8798;
  border-radius: 3px;
  transform: rotate(-35deg);
}

.brush-button::after {
  content: "";
  width: 10px;
  height: 3px;
  position: absolute;
  left: 11px;
  top: 25px;
  background: #7e8798;
  border-radius: 4px;
  transform: rotate(-35deg);
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 0 20px 14px;
  background: #20222f;
}

.category-grid button {
  height: 44px;
  color: #aeb6c6;
  background: #2b2e3c;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 900;
  cursor: pointer;
}

.category-grid button:nth-last-child(-n + 2) {
  grid-column: span 2;
}

.category-grid button.active {
  color: #fff0d0;
  background: rgba(255, 138, 31, 0.12);
  border-color: rgba(255, 138, 31, 0.48);
  box-shadow: 0 0 22px rgba(255, 138, 31, 0.1);
}

.case-section {
  padding: 6px 20px 48px;
}

.case-section h2 {
  height: 44px;
  margin: 0;
  color: #e3e8f2;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(130px, 1fr));
  gap: 10px;
}

.case-card {
  min-height: 228px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  color: #edf1f3;
  background: linear-gradient(180deg, #20222f, #1a1c27);
  border: 0;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
}

.case-card::before {
  content: "";
  position: absolute;
  inset: 44px 10px 64px;
  background: radial-gradient(circle, var(--case-glow, rgba(136, 72, 255, 0.42)), transparent 62%);
  filter: blur(2px);
}

.case-card::after {
  content: "";
  width: 138px;
  height: 84px;
  position: absolute;
  left: 50%;
  top: 60px;
  background: conic-gradient(from 10deg, transparent, var(--case-ring, rgba(136, 72, 255, 0.56)), transparent 38%, var(--case-ring, rgba(136, 72, 255, 0.42)), transparent 72%);
  border-radius: 50%;
  opacity: 0.75;
  filter: blur(7px);
  transform: translateX(-50%);
}

.case-card:nth-child(1) {
  --case-glow: rgba(150, 74, 255, 0.46);
  --case-ring: rgba(175, 92, 255, 0.72);
}

.case-card:nth-child(2) {
  --case-glow: rgba(235, 98, 255, 0.42);
  --case-ring: rgba(255, 126, 238, 0.58);
}

.case-card:nth-child(3) {
  --case-glow: rgba(255, 132, 34, 0.44);
  --case-ring: rgba(255, 162, 51, 0.62);
}

.case-card:nth-child(4) {
  --case-glow: rgba(40, 220, 135, 0.42);
  --case-ring: rgba(69, 255, 144, 0.58);
}

.case-card:nth-child(5) {
  --case-glow: rgba(42, 116, 255, 0.46);
  --case-ring: rgba(70, 181, 255, 0.58);
}

.case-card:nth-child(6) {
  --case-glow: rgba(50, 224, 255, 0.44);
  --case-ring: rgba(72, 226, 255, 0.62);
}

.case-card:nth-child(7) {
  --case-glow: rgba(255, 73, 37, 0.45);
  --case-ring: rgba(255, 93, 35, 0.62);
}

.case-card:nth-child(8) {
  --case-glow: rgba(220, 220, 210, 0.38);
  --case-ring: rgba(255, 229, 178, 0.52);
}

.case-value {
  position: relative;
  z-index: 1;
  color: #6f7685;
  font-size: 11px;
  font-weight: 900;
}

.case-image {
  height: 122px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-image img {
  max-width: 166px;
  max-height: 126px;
  position: relative;
  z-index: 1;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 22px 22px rgba(0, 0, 0, 0.48));
  transform: translateY(8px) scale(1.08);
}

.case-card strong {
  display: block;
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 16px;
  line-height: 1.2;
}

.case-card em {
  display: block;
  position: relative;
  z-index: 1;
  margin-top: 4px;
  color: #6f7685;
  font-size: 12px;
  font-style: normal;
}

.case-price {
  position: relative;
  z-index: 1;
  margin-top: 12px;
  color: #edb145;
  font-weight: 900;
}

@media screen and (max-width: 1100px) {
  .hp-page {
    grid-template-columns: 1fr;
    overflow: auto;
  }

  .hp-sidebar {
    position: relative;
    width: 100%;
    min-width: 0;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding-bottom: 12px;
  }

  .brand-block {
    grid-column: 1 / -1;
  }

  .free-case-card,
  .bonus-card {
    display: none;
  }

  .hp-main {
    height: auto;
    overflow: visible;
  }

  .live-strip,
  .mode-strip,
  .battle-list,
  .filter-strip,
  .category-grid,
  .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .battle-strip {
    height: auto;
    grid-template-columns: 1fr;
    padding-left: 10px;
  }

  .pvp-label {
    display: none;
  }
}

@media screen and (max-width: 640px) {
  .live-strip,
  .mode-strip,
  .battle-list,
  .filter-strip,
  .category-grid,
  .case-grid {
    grid-template-columns: 1fr;
  }
}

.hp-page {
  display: block !important;
  height: auto !important;
  overflow: visible !important;
}

.hp-sidebar,
.live-strip,
.mode-strip {
  display: none !important;
}

.hp-main {
  height: auto !important;
  overflow: visible !important;
}

/* HotPizza 2026 visual pass: homepage first-screen structure. */
.hp-main {
  min-height: calc(100vh - 202px) !important;
  padding: 0 0 90px;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 132, 26, 0.06), transparent 26%),
    linear-gradient(180deg, #202331 0, #1a1c27 360px, #171923 100%) !important;
}

.battle-strip {
  height: 166px;
  min-height: 166px;
  grid-template-columns: 76px minmax(0, 1fr);
  padding: 10px 12px 12px 14px;
  background: #202331;
  border-top: 1px solid rgba(255, 255, 255, 0.025);
  border-bottom: 1px solid #2b2e3d;
}

.pvp-label {
  color: #fff3d4;
  background: linear-gradient(180deg, #2a2d3b, #222531);
  border-radius: 8px 0 0 8px;
}

.pvp-label span {
  text-orientation: mixed;
  letter-spacing: 1px;
}

.battle-list {
  grid-template-columns: repeat(3, minmax(310px, 1fr));
  gap: 10px;
  overflow: hidden;
}

.battle-card {
  height: 144px;
  border-radius: 9px;
  background:
    radial-gradient(circle at 50% 30%, rgba(255, 149, 37, 0.1), transparent 34%),
    linear-gradient(180deg, #303241, #292b38);
  border: 1px solid rgba(255, 255, 255, 0.025);
  box-shadow:
    inset 0 -76px 64px rgba(20, 21, 30, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.battle-card::before {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  left: 15px;
  top: 14px;
  border-radius: 50%;
  background: #ff8a1f;
  box-shadow: 0 0 12px rgba(255, 138, 31, 0.85);
}

.battle-top {
  top: 15px;
  left: 30px;
  right: 28px;
  color: #b5becd;
  font-size: 15px;
}

.battle-watch {
  top: 44px;
  width: 126px;
  height: 35px;
  color: #fff6df;
  border-color: rgba(255, 238, 204, 0.86);
  border-radius: 6px;
  font-size: 16px;
}

.battle-card strong {
  top: 45px;
  right: 32px;
  font-size: 20px;
}

.battle-items {
  height: 72px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background: rgba(29, 31, 43, 0.72);
  border-top: 1px solid rgba(174, 181, 202, 0.18);
}

.battle-items img {
  height: 72px;
  padding: 7px 16px;
  object-fit: contain;
  border-left: 1px solid rgba(120, 126, 150, 0.22);
  filter:
    drop-shadow(0 15px 20px rgba(0, 0, 0, 0.44))
    drop-shadow(0 0 18px rgba(255, 132, 31, 0.16));
}

.filter-strip {
  width: calc(100% - 40px);
  max-width: 1580px;
  min-height: 82px;
  margin: 28px auto 0;
  padding: 14px;
  display: grid;
  grid-template-columns: minmax(260px, 1fr) 220px minmax(430px, 0.9fr) 54px;
  gap: 12px;
  align-items: center;
  background: linear-gradient(180deg, rgba(43, 46, 60, 0.96), rgba(32, 35, 48, 0.96));
  border: 1px solid rgba(255, 255, 255, 0.045);
  border-radius: 10px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.26);
}

.search-box,
.switch-filter,
.price-filter,
.brush-button {
  height: 54px;
  border-radius: 8px;
  background: #252837;
  border: 1px solid rgba(255, 255, 255, 0.035);
}

.search-box input {
  color: #d8deea;
  font-size: 15px;
}

.switch-filter,
.price-filter {
  color: #9da7b8;
  font-size: 14px;
  font-weight: 900;
}

.price-filter strong {
  color: #fff2d0;
}

.category-grid {
  width: calc(100% - 40px);
  max-width: 1580px;
  margin: 16px auto 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}

.category-grid button {
  height: 47px;
  color: #abb4c5;
  background: linear-gradient(180deg, #2b2e3d, #242735);
  border: 1px solid rgba(255, 255, 255, 0.035);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 1000;
  text-transform: uppercase;
}

.category-grid button:hover {
  color: #fff0d0;
  border-color: rgba(255, 138, 31, 0.35);
  box-shadow: inset 0 -20px 30px rgba(255, 138, 31, 0.08);
}

.case-section {
  width: calc(100% - 40px);
  max-width: 1580px;
  margin: 28px auto 0;
}

.case-section h2 {
  margin: 0 0 18px;
  color: #f0f3f8;
  font-size: 24px;
  line-height: 1.1;
  font-weight: 1000;
  text-align: left;
}

.case-section h2::after {
  content: "";
  width: 66px;
  height: 3px;
  margin-top: 9px;
  display: block;
  border-radius: 999px;
  background: linear-gradient(90deg, #ff8a1f, transparent);
}

.case-grid {
  grid-template-columns: repeat(4, minmax(240px, 1fr));
  gap: 18px;
}

.case-card {
  min-height: 302px;
  padding: 18px 16px 16px;
  overflow: hidden;
  border-radius: 12px;
  background:
    radial-gradient(circle at 50% 39%, var(--case-glow, rgba(133, 67, 255, 0.36)), transparent 42%),
    linear-gradient(180deg, #292c3a 0, #242735 100%);
  border: 1px solid rgba(255, 255, 255, 0.045);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    0 16px 34px rgba(0, 0, 0, 0.2);
  transition: transform 0.18s ease, border-color 0.18s ease, filter 0.18s ease;
}

.case-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 138, 31, 0.34);
  filter: brightness(1.08);
}

.case-card::before {
  width: 280px;
  height: 115px;
  top: 82px;
  background: radial-gradient(ellipse, rgba(255, 255, 255, 0.08), transparent 66%);
}

.case-value {
  height: 26px;
  padding: 0 11px;
  color: #ffb347;
  background: rgba(255, 138, 31, 0.1);
  border: 1px solid rgba(255, 138, 31, 0.16);
  border-radius: 999px;
  font-size: 12px;
  line-height: 24px;
  font-weight: 1000;
}

.case-image {
  height: 166px;
  margin-top: 18px;
}

.case-image img {
  max-width: 94%;
  max-height: 162px;
  filter:
    drop-shadow(0 24px 28px rgba(0, 0, 0, 0.44))
    drop-shadow(0 0 22px rgba(255, 255, 255, 0.08));
}

.case-card strong {
  margin-top: 6px;
  color: #ffffff;
  font-size: 18px;
  line-height: 22px;
  font-weight: 1000;
}

.case-card em {
  color: #8f98aa;
  font-size: 13px;
  font-weight: 900;
}

.case-price {
  min-width: 88px;
  height: 36px;
  margin: 13px auto 0;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff3d5;
  background: linear-gradient(180deg, #ff9d1f, #f46b00);
  border-radius: 6px;
  font-size: 16px;
  font-weight: 1000;
  box-shadow: 0 10px 20px rgba(244, 107, 0, 0.22);
}

@media screen and (max-width: 1280px) {
  .battle-list,
  .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filter-strip {
    grid-template-columns: 1fr 1fr;
  }

  .category-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* HotPizza exact-pass: homepage geometry aligned to the shared 250/115/84 shell. */
.hp-page {
  min-height: 100vh;
  padding-left: 250px;
  padding-top: 199px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 139, 31, 0.045), transparent 360px),
    linear-gradient(180deg, #20222f 0, #1c1e29 420px, #171923 100%) !important;
}

.hp-main {
  min-height: calc(100vh - 199px) !important;
  background: transparent !important;
}

.battle-strip {
  height: 158px;
  min-height: 158px;
  grid-template-columns: 92px minmax(0, 1fr);
  padding: 8px 14px 12px;
  background: #20222f;
  border-top: 1px solid #2b2d3c;
  border-bottom: 1px solid #2b2d3c;
}

.pvp-label {
  height: 138px;
  color: #fff1d0;
  background: #252837;
  border-radius: 8px 0 0 8px;
  font-size: 18px;
}

.pvp-label span {
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 1px;
}

.battle-list {
  display: flex;
  gap: 8px;
  min-height: 138px;
  overflow: hidden;
}

.battle-card {
  width: 394px;
  min-width: 394px;
  height: 138px;
  border-radius: 7px;
  background:
    linear-gradient(90deg, rgba(255, 138, 31, 0.1), transparent 42%),
    linear-gradient(180deg, #2d2f3d, #282a37);
  border: 1px solid rgba(255, 138, 31, 0.18);
  box-shadow: inset 0 -70px 58px rgba(22, 23, 33, 0.38);
}

.battle-top {
  top: 15px;
  left: 28px;
  right: 30px;
  color: #c2c9d6;
  font-size: 16px;
}

.battle-watch {
  top: 40px;
  width: 124px;
  height: 34px;
  border-radius: 5px;
  color: #fff0d0;
  font-size: 16px;
}

.battle-card strong {
  top: 42px;
  right: 30px;
  color: #ffbd46;
  font-size: 20px;
}

.battle-items {
  height: 68px;
}

.battle-items img {
  height: 68px;
  padding: 4px 12px 0;
}

.filter-strip,
.category-grid,
.case-section {
  width: calc(100% - 48px);
  max-width: none;
}

.filter-strip {
  min-height: 74px;
  margin-top: 22px;
  grid-template-columns: minmax(260px, 350px) 230px minmax(380px, 1fr) 48px;
  background: #20222f;
  border-color: #2b2e3d;
  box-shadow: none;
}

.search-box,
.switch-filter,
.price-filter,
.brush-button {
  height: 48px;
  background: #252837;
}

.category-grid {
  grid-template-columns: repeat(7, minmax(122px, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.category-grid button {
  height: 42px;
  border-radius: 6px;
  background: #292c3a;
}

.case-section {
  margin-top: 24px;
}

.case-grid {
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  gap: 14px;
}

.case-card {
  min-height: 278px;
  border-radius: 9px;
  background:
    radial-gradient(circle at 50% 38%, var(--case-glow, rgba(111, 67, 246, 0.34)), transparent 42%),
    linear-gradient(180deg, #292c3a, #242735);
}

.case-image {
  height: 154px;
}

.case-image img {
  max-height: 150px;
}

@media screen and (max-width: 1280px) {
  .hp-page {
    padding-left: 0;
  }

  .battle-card {
    width: 360px;
    min-width: 360px;
  }

  .filter-strip {
    grid-template-columns: 1fr 1fr;
  }

  .category-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>

<style lang="less">
body:has(.hp-page) .hp-page .case-image .case-hidden-gold img {
  width: 44px !important;
  max-width: 44px !important;
  height: 44px !important;
  max-height: 44px !important;
  position: static !important;
  inset: auto !important;
  object-fit: contain !important;
  opacity: 1 !important;
  transform: none !important;
  filter: none !important;
}

@media screen and (max-width: 640px) {
  body:has(.hp-page) .hp-page .case-image .case-hidden-gold {
    width: 38px;
    height: 38px;
    top: 6px;
    right: 6px;
  }

  body:has(.hp-page) .hp-page .case-image .case-hidden-gold img {
    width: 36px !important;
    max-width: 36px !important;
    height: 36px !important;
    max-height: 36px !important;
  }
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: home density, carousel width and case grid final trim. */
body:has(.hp-page) .hp-page {
  padding-top: 0 !important;
  background:
    radial-gradient(ellipse at 50% 126px, rgba(255, 139, 31, 0.1), transparent 470px),
    #191b26 !important;
}

body:has(.hp-page) .hp-page .hp-main {
  min-height: calc(100vh - 202px) !important;
  padding: 197px 0 90px !important;
}

body:has(.hp-page) .hp-page .battle-strip,
body:has(.hp-page) .hp-page .filter-strip,
body:has(.hp-page) .hp-page .category-grid,
body:has(.hp-page) .hp-page .case-section {
  width: 100% !important;
  max-width: none !important;
}

body:has(.hp-page) .hp-page .battle-strip {
  display: grid !important;
  height: 150px !important;
  min-height: 150px !important;
  padding: 7px 20px !important;
  box-sizing: border-box;
  grid-template-columns: 76px minmax(0, 1fr) !important;
  background:
    linear-gradient(180deg, rgba(34, 36, 48, 0.88), rgba(25, 27, 38, 0.96)),
    radial-gradient(ellipse at 50% 0, rgba(253, 107, 1, 0.12), transparent 48%) !important;
}

body:has(.hp-page) .hp-page .battle-track {
  gap: 8px !important;
}

body:has(.hp-page) .hp-page .pvp-label {
  width: 76px !important;
  height: 136px !important;
}

body:has(.hp-page) .hp-page .battle-list {
  display: flex !important;
  grid-template-columns: none !important;
  gap: 8px !important;
  height: 136px !important;
  min-height: 136px !important;
  overflow: hidden !important;
}

body:has(.hp-page) .hp-page .battle-card {
  width: 390px !important;
  min-width: 390px !important;
  height: 136px !important;
  border-radius: 8px !important;
  border-color: rgba(236, 216, 184, 0.1) !important;
  background:
    radial-gradient(circle at 42% 80%, rgba(253, 107, 1, 0.1), transparent 50%),
    #20222f !important;
  box-shadow: none !important;
}

.battle-card-enter-active {
  transition: opacity 0.34s ease-out, transform 0.34s ease-out;
}

.battle-card-enter {
  opacity: 0;
  transform: translateX(-22px);
}

body:has(.hp-page) .hp-page .battle-top {
  top: 10px !important;
  left: 18px !important;
  right: 18px !important;
  font-size: 13px !important;
}

body:has(.hp-page) .hp-page .battle-watch {
  top: 37px !important;
  width: 108px !important;
  height: 30px !important;
  font-size: 14px !important;
}

body:has(.hp-page) .hp-page .battle-card > strong {
  top: 41px !important;
  right: 20px !important;
  font-size: 17px !important;
}

body:has(.hp-page) .hp-page .battle-items,
body:has(.hp-page) .hp-page .battle-items img {
  height: 64px !important;
}

body:has(.hp-page) .hp-page .battle-items img {
  padding: 3px 11px 0 !important;
}

body:has(.hp-page) .hp-page .battle-item {
  min-width: 0;
  position: relative;
}

body:has(.hp-page) .hp-page .battle-item img {
  display: block;
}

body:has(.hp-page) .hp-page .battle-item span {
  min-width: 21px;
  padding: 2px 4px;
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 7px;
  color: #ffd58a;
  background: rgba(26, 28, 39, 0.74);
  border-radius: 3px;
  font-size: 11px;
  font-weight: 1000;
  line-height: 1;
  text-align: center;
}

body:has(.hp-page) .hp-page .battle-player-row {
  display: none !important;
}

body:has(.hp-page) .hp-page .battle-player-row img {
  width: 30px;
  height: 30px;
  margin-left: -6px;
  display: block;
  object-fit: cover;
  border: 2px solid #20222f;
  border-radius: 50%;
  background: #303342;
  box-shadow: 0 0 0 1px rgba(255, 176, 53, 0.28), 0 3px 9px rgba(0, 0, 0, 0.32);
}

body:has(.hp-page) .hp-page .battle-player-row img:first-child {
  margin-left: 0;
}

body:has(.hp-page) .hp-page .battle-player-row i {
  min-width: 22px;
  margin: 0 4px;
  color: #8992a4;
  font-size: 9px;
  font-style: normal;
  font-weight: 1000;
  letter-spacing: 0.04em;
  text-align: center;
}

body:has(.hp-page) .hp-page .filter-strip {
  min-height: 64px !important;
  margin-top: 18px !important;
  border-radius: 8px !important;
  grid-template-columns: minmax(250px, 340px) 210px minmax(360px, 1fr) 46px !important;
}

body:has(.hp-page) .hp-page .category-grid {
  grid-template-columns: repeat(8, minmax(106px, 1fr)) !important;
  gap: 8px !important;
}

body:has(.hp-page) .hp-page .case-grid {
  grid-template-columns: repeat(auto-fill, minmax(214px, 1fr)) !important;
  gap: 10px !important;
}

body:has(.hp-page) .hp-page .case-card {
  min-height: 264px !important;
  border-radius: 8px !important;
  border-color: #2b2d3c !important;
  background:
    radial-gradient(circle at 50% 40%, var(--case-glow, rgba(111, 67, 246, 0.34)), transparent 45%),
    #20222f !important;
  box-shadow: none !important;
}

body:has(.hp-page) .hp-page .case-image {
  height: 146px !important;
}

body:has(.hp-page) .hp-page .case-image img {
  max-height: 144px !important;
  mix-blend-mode: lighten !important;
  filter:
    drop-shadow(0 24px 28px rgba(0, 0, 0, 0.44))
    drop-shadow(0 0 24px var(--case-ring, rgba(255, 255, 255, 0.12))) !important;
}

body:has(.hp-page) .hp-page .case-card:hover .case-image img {
  transform: translateY(4px) scale(1.12) !important;
}

/* Keep the target-style price track while exposing the real box-price range. */
body:has(.hp-page) .hp-page .price-filter .range-line {
  height: 4px;
  overflow: visible;
  background: #3a3e50;
}

body:has(.hp-page) .hp-page .price-filter .range-fill {
  position: absolute;
  top: 0;
  height: 4px;
  border-radius: inherit;
  background: linear-gradient(90deg, #ff8a00, #ffd56d);
  box-shadow: 0 0 10px rgba(255, 148, 20, 0.55);
}

body:has(.hp-page) .hp-page .price-filter .price-range-input {
  position: absolute;
  top: -7px;
  left: 0;
  width: 100%;
  height: 18px;
  margin: 0;
  appearance: none;
  pointer-events: none;
  background: transparent;
}

body:has(.hp-page) .hp-page .price-filter .price-range-input::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  appearance: none;
  pointer-events: auto;
  cursor: pointer;
  border: 2px solid #fff1cf;
  border-radius: 50%;
  background: #ff9a16;
  box-shadow: 0 0 0 3px rgba(255, 143, 12, 0.2), 0 0 12px rgba(255, 143, 12, 0.7);
}

body:has(.hp-page) .hp-page .pk-home-footer {
  width: 100%;
  margin-top: 44px;
  padding: 0 24px 40px;
  box-sizing: border-box;
}

body:has(.hp-page) .hp-page .pk-home-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid #2b2d3c;
  border-bottom: 1px solid #2b2d3c;
  background: linear-gradient(90deg, rgba(37, 40, 54, 0.7), rgba(28, 30, 42, 0.98), rgba(37, 40, 54, 0.7));
}

body:has(.hp-page) .hp-page .pk-home-stats article {
  min-height: 138px;
  padding: 28px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

body:has(.hp-page) .hp-page .pk-home-stats article + article {
  border-left: 1px solid #2b2d3c;
}

body:has(.hp-page) .hp-page .pk-home-stats span {
  color: #7f899b;
  font-size: 11px;
  font-weight: 1000;
  letter-spacing: 0.16em;
}

body:has(.hp-page) .hp-page .pk-home-stats strong {
  margin: 7px 0 4px;
  color: #ffd266;
  font-size: 32px;
  line-height: 1;
  font-weight: 1000;
  text-shadow: 0 0 18px rgba(255, 173, 42, 0.18);
}

body:has(.hp-page) .hp-page .pk-home-stats em {
  color: #bac2d1;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom {
  min-height: 106px;
  padding: 22px 30px;
  display: grid;
  grid-template-columns: 200px 1fr auto;
  align-items: center;
  gap: 28px;
  box-sizing: border-box;
  background: #191b26;
  border-bottom: 1px solid #2b2d3c;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom button.pk-footer-brand {
  min-width: 190px;
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 9px;
  color: #fff7dc;
  text-align: left;
  cursor: pointer;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-brand img {
  width: 58px;
  height: 58px;
  flex: 0 0 58px;
  object-fit: contain;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-brand strong {
  font-size: 21px;
  font-weight: 950;
  letter-spacing: -0.045em;
  line-height: 1;
  white-space: nowrap;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-brand strong span {
  color: #ff8a16;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 22px;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-copy {
  min-width: 320px;
  grid-column: 2;
  grid-row: 1;
  text-align: center;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-copy p {
  max-width: 760px;
  margin: 13px auto 0;
  color: #737d90;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.7;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom button {
  padding: 0;
  color: #a7b0c0;
  background: transparent;
  border: 0;
  font-size: 13px;
  font-weight: 900;
  cursor: pointer;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom button:hover {
  color: #ffd266;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom small {
  grid-column: 3;
  grid-row: 1;
  color: #626c7e;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-network-row {
  width: 100%;
  grid-column-start: 1;
  grid-column-end: -1;
  grid-row: 2;
}

@media screen and (max-width: 780px) {
  body:has(.hp-page) .hp-page .pk-home-footer {
    padding: 0 12px 28px;
  }

  body:has(.hp-page) .hp-page .pk-home-stats,
  body:has(.hp-page) .hp-page .pk-home-footer-bottom {
    grid-template-columns: 1fr;
  }

  body:has(.hp-page) .hp-page .pk-home-stats article + article {
    border-top: 1px solid #2b2d3c;
    border-left: 0;
  }

  body:has(.hp-page) .hp-page .pk-home-footer-bottom {
    text-align: center;
  }

  body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-brand {
    grid-column: 1;
    grid-row: auto;
    justify-self: center;
  }

  body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-copy,
  body:has(.hp-page) .hp-page .pk-home-footer-bottom small {
    min-width: 0;
    grid-column: 1;
    grid-row: auto;
  }

  body:has(.hp-page) .hp-page .pk-home-footer-bottom .pk-footer-network-row {
    grid-column: 1;
    grid-row: auto;
    text-align: left;
  }
}
</style>

<style lang="less">
/* HotPizza pvp-short desktop geometry. */
body:has(.hp-page) .hp-page .battle-strip {
  height: 157px !important;
  min-height: 157px !important;
  padding: 0 !important;
  grid-template-columns: 76px minmax(0, 1fr) !important;
  background: #1c1d29 !important;
  border: 0 !important;
}

body:has(.hp-page) .hp-page .pvp-label {
  width: 36px !important;
  height: 157px !important;
  gap: 10px;
  padding: 0 20px;
  color: #ecd8b8;
  background: #1c1d29;
  border-radius: 0;
  font-size: 16px;
}

body:has(.hp-page) .hp-page .battle-list {
  height: 157px !important;
  min-height: 157px !important;
  align-items: center;
  gap: 10px !important;
}

body:has(.hp-page) .hp-page .battle-card {
  width: 394px !important;
  min-width: 394px !important;
  height: 137px !important;
  border-radius: 10px !important;
}

body:has(.hp-page) .hp-page .battle-top {
  top: 14px !important;
  left: 20px !important;
  right: 20px !important;
  font-size: 12px !important;
}

body:has(.hp-page) .hp-page .battle-watch {
  top: 18px !important;
}

body:has(.hp-page) .hp-page .battle-card > strong {
  top: 33px !important;
  right: 20px !important;
  font-size: 14px !important;
}

body:has(.hp-page) .hp-page .battle-items,
body:has(.hp-page) .hp-page .battle-items img {
  height: 70px !important;
}

/* Measured desktop geometry from the public target homepage. */
@media screen and (min-width: 981px) {
  body:has(.hp-page) .hp-page .filter-strip {
    height: 82px !important;
    min-height: 82px !important;
    margin-top: 0 !important;
    padding: 20px !important;
    box-sizing: border-box;
    border: 0 !important;
    grid-template-columns: 267px 220px minmax(360px, 1fr) 46px !important;
  }

  body:has(.hp-page) .hp-page .search-box,
  body:has(.hp-page) .hp-page .switch-filter,
  body:has(.hp-page) .hp-page .price-filter,
  body:has(.hp-page) .hp-page .brush-button {
    height: 42px !important;
    box-sizing: border-box;
  }

  body:has(.hp-page) .hp-page .category-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    gap: 10px !important;
    margin-top: 0 !important;
    min-height: 116px;
    padding: 0 20px 14px !important;
    box-sizing: border-box;
  }

  body:has(.hp-page) .hp-page .case-section {
    margin-top: 14px !important;
  }

  body:has(.hp-page) .hp-page .case-card em {
    display: none !important;
  }

  body:has(.hp-page) .hp-page .case-image img {
    transform: translateY(-12px) scale(1.24) !important;
  }

  body:has(.hp-page) .hp-page .case-price {
    min-width: 0 !important;
    height: auto !important;
    margin-top: 7px !important;
    padding: 0 !important;
    color: #ffb43a !important;
    background: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  /* Match the target's light case-gallery hierarchy without changing the live catalog. */
  body:has(.hp-page) .hp-page .case-section h2 {
    height: auto !important;
    margin: 0 0 10px !important;
    color: #eef1f8 !important;
    font-size: 16px !important;
    line-height: 1.2 !important;
  }

  body:has(.hp-page) .hp-page .case-section h2::after,
  body:has(.hp-page) .hp-page .case-value {
    display: none !important;
  }

  body:has(.hp-page) .hp-page .case-grid {
    gap: 8px !important;
  }

  body:has(.hp-page) .hp-page .case-card {
    min-height: 298px !important;
    padding: 10px 8px 12px !important;
    background: transparent !important;
    border-color: transparent !important;
    border-radius: 0 !important;
  }

  body:has(.hp-page) .hp-page .case-card::before {
    inset: 28px 0 70px !important;
  }

  body:has(.hp-page) .hp-page .case-image {
    height: 182px !important;
    margin-top: 0 !important;
  }

  body:has(.hp-page) .hp-page .case-image img {
    max-height: 178px !important;
    transform: translateY(-10px) scale(1.3) !important;
  }

  body:has(.hp-page) .hp-page .case-card strong {
    margin-top: 3px !important;
    color: #d3d9e5 !important;
    font-size: 15px !important;
    line-height: 19px !important;
    text-align: center !important;
  }

  body:has(.hp-page) .hp-page .case-price {
    width: 100% !important;
    margin-top: 6px !important;
    justify-content: center !important;
    font-size: 16px !important;
  }
}

@media screen and (min-width: 981px) {
  body:has(.hp-page) .hp-page {
    padding-left: 250px !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.hp-page) .hp-page {
    padding-left: 0 !important;
  }
}

.case-hidden-gold {
  width: 46px;
  height: 46px;
  padding: 0;
  position: absolute;
  z-index: 5;
  top: 8px;
  right: 8px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  box-shadow: none;
  pointer-events: none;
}

.case-hidden-gold img {
  width: 44px !important;
  height: 44px !important;
  object-fit: contain !important;
  transform: none !important;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, .38)) !important;
}

body:has(.hp-page) .hp-page .battle-mobile-meta {
  display: none;
}

/* Keep the target card hierarchy readable on a phone instead of inheriting desktop minimum widths. */
@media screen and (max-width: 640px) {
  body:has(.hp-page) .hp-page,
  body:has(.hp-page) .hp-page .hp-main {
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }

  body:has(.hp-page) .hp-page .hp-main {
    min-height: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 94px !important;
  }

  body:has(.hp-page) .hp-page .battle-strip {
    height: 154px !important;
    min-height: 154px !important;
    padding: 8px 0 !important;
    grid-template-columns: minmax(0, 1fr) !important;
  }

  body:has(.hp-page) .hp-page .pvp-label {
    display: none !important;
  }

  body:has(.hp-page) .hp-page .battle-list {
    width: 100% !important;
    height: 138px !important;
    min-height: 138px !important;
    padding: 0 12px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scroll-snap-type: x mandatory;
    -ms-overflow-style: none;
    scrollbar-width: none;
    box-sizing: border-box !important;
  }

  body:has(.hp-page) .hp-page .battle-list::-webkit-scrollbar,
  body:has(.hp-page) .hp-page .category-grid::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  body:has(.hp-page) .hp-page .battle-card {
    width: calc(100vw - 24px) !important;
    min-width: calc(100vw - 24px) !important;
    scroll-snap-align: start;
  }

  body:has(.hp-page) .hp-page .battle-top {
    left: 14px !important;
    right: 14px !important;
  }

  body:has(.hp-page) .hp-page .battle-top em {
    display: none !important;
  }

  body:has(.hp-page) .hp-page .battle-card > strong {
    display: none !important;
  }

  body:has(.hp-page) .hp-page .battle-mobile-meta {
    position: absolute;
    z-index: 5;
    top: 14px;
    right: 14px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    color: #c2c9d6;
    font-size: 12px;
    font-weight: 900;
    line-height: 1;
    white-space: nowrap;
  }

  body:has(.hp-page) .hp-page .battle-mobile-meta strong {
    position: static !important;
    top: auto !important;
    right: auto !important;
    height: auto !important;
    display: block !important;
    color: #ffbd46;
    font-size: 17px;
    font-weight: 1000;
  }

  body:has(.hp-page) .hp-page .battle-mobile-meta span {
    position: static !important;
    display: block !important;
  }

  body:has(.hp-page) .hp-page .filter-strip {
    width: 100% !important;
    min-height: 0 !important;
    margin-top: 14px !important;
    padding: 12px !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 10px !important;
    box-sizing: border-box !important;
  }

  body:has(.hp-page) .hp-page .search-box,
  body:has(.hp-page) .hp-page .switch-filter,
  body:has(.hp-page) .hp-page .price-filter,
  body:has(.hp-page) .hp-page .brush-button {
    width: 100% !important;
  }

  body:has(.hp-page) .hp-page .category-grid {
    width: 100% !important;
    margin-top: 0 !important;
    padding: 0 12px 12px !important;
    display: flex !important;
    gap: 8px !important;
    overflow-x: auto !important;
    -ms-overflow-style: none;
    scrollbar-width: none;
    box-sizing: border-box !important;
  }

  body:has(.hp-page) .hp-page .category-grid button {
    min-width: 126px !important;
    flex: 0 0 126px !important;
  }

  body:has(.hp-page) .hp-page .case-section {
    width: 100% !important;
    padding: 0 12px !important;
    box-sizing: border-box !important;
  }

  body:has(.hp-page) .hp-page .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  body:has(.hp-page) .hp-page .case-card {
    min-height: 232px !important;
  }

  body:has(.hp-page) .hp-page .case-image {
    height: 126px !important;
  }

  body:has(.hp-page) .hp-page .case-image img {
    max-height: 122px !important;
  }
}

body:has(.hp-page) .hp-page .case-image .case-hidden-gold img {
  width: 44px !important;
  max-width: 44px !important;
  height: 44px !important;
  max-height: 44px !important;
  position: static !important;
  inset: auto !important;
  object-fit: contain !important;
  opacity: 1 !important;
  transform: none !important;
  filter: none !important;
}
</style>

<style lang="less">
/* HotPizza case gallery: uploaded effect art sits behind the uploaded case art. */
body:has(.hp-page) .hp-page .case-section {
  width: calc(100% - 40px) !important;
  max-width: none !important;
  padding: 14px 0 20px !important;
  overflow: hidden;
  border-radius: 10px;
  background: #1c1e2a;
}

body:has(.hp-page) .hp-page .case-section h2 {
  padding: 0 16px !important;
}

body:has(.hp-page) .hp-page .case-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 0 !important;
}

body:has(.hp-page) .hp-page .case-card {
  min-width: 0 !important;
  min-height: 286px !important;
  padding: 4px 8px 14px !important;
  overflow: hidden !important;
  background: transparent !important;
  border: 0 !important;
  border-right: 1px solid rgba(54, 57, 73, 0.56) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  transform: none !important;
  filter: none !important;
}

body:has(.hp-page) .hp-page .case-card:nth-child(6n) {
  border-right-color: transparent !important;
}

body:has(.hp-page) .hp-page .case-card::before,
body:has(.hp-page) .hp-page .case-card::after {
  display: none !important;
}

body:has(.hp-page) .hp-page .case-image {
  height: 194px !important;
  margin-top: 0 !important;
  position: relative;
  overflow: visible;
  isolation: isolate;
}

body:has(.hp-page) .hp-page .case-image img {
  position: absolute !important;
  top: 50%;
  left: 50%;
  margin: 0 !important;
  object-fit: contain;
  transition: opacity 0.2s ease, transform 0.22s ease, filter 0.22s ease !important;
}

body:has(.hp-page) .hp-page .case-image .case-image-effect {
  z-index: 0;
  width: 126% !important;
  max-width: 230px !important;
  height: 126% !important;
  max-height: 230px !important;
  opacity: 0.96;
  mix-blend-mode: screen !important;
  filter: saturate(1.12) brightness(1.04) !important;
  transform: translate(-50%, -50%) scale(1) !important;
}

body:has(.hp-page) .hp-page .case-image .case-image-main {
  z-index: 1;
  width: 92% !important;
  max-width: 174px !important;
  height: 92% !important;
  max-height: 174px !important;
  mix-blend-mode: normal !important;
  filter: drop-shadow(0 22px 24px rgba(0, 0, 0, 0.38)) !important;
  transform: translate(-50%, -48%) scale(1) !important;
}

body:has(.hp-page) .hp-page .case-open-overlay {
  position: absolute;
  z-index: 4;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  color: #f3bf54;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.18s ease, transform 0.18s ease;
  pointer-events: none;
}

body:has(.hp-page) .hp-page .case-open-overlay b {
  font-size: 14px;
  font-weight: 1000;
  line-height: 1;
  text-shadow: 0 0 14px rgba(255, 173, 31, 0.5);
}

body:has(.hp-page) .hp-page .case-open-pizza {
  width: 60px;
  height: 60px;
  display: block;
  background: url("../assets/pizzaking/case-open-pizza.svg") center / contain no-repeat;
  filter: drop-shadow(0 0 10px rgba(255, 176, 35, 0.54));
}

body:has(.hp-page) .hp-page .case-card:hover .case-image-main,
body:has(.hp-page) .hp-page .case-card:focus-visible .case-image-main {
  opacity: 0.2;
  filter: brightness(0.5) saturate(0.7) !important;
  transform: translate(-50%, -48%) scale(0.98) !important;
}

body:has(.hp-page) .hp-page .case-card:hover .case-image-effect,
body:has(.hp-page) .hp-page .case-card:focus-visible .case-image-effect {
  opacity: 0.14;
  filter: brightness(0.48) saturate(0.7) !important;
  transform: translate(-50%, -50%) scale(1.03) !important;
}

body:has(.hp-page) .hp-page .case-card:hover .case-open-overlay,
body:has(.hp-page) .hp-page .case-card:focus-visible .case-open-overlay {
  opacity: 1;
  transform: translateY(0);
}

body:has(.hp-page) .hp-page .case-card:focus-visible {
  outline: 1px solid #f3bf54 !important;
  outline-offset: -1px;
}

@media screen and (max-width: 980px) {
  body:has(.hp-page) .hp-page .case-section {
    width: calc(100% - 24px) !important;
    padding: 12px 0 16px !important;
  }

  body:has(.hp-page) .hp-page .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  body:has(.hp-page) .hp-page .case-card {
    min-height: 270px !important;
  }

  body:has(.hp-page) .hp-page .case-card:nth-child(6n) {
    border-right-color: rgba(54, 57, 73, 0.56) !important;
  }

  body:has(.hp-page) .hp-page .case-card:nth-child(2n) {
    border-right-color: transparent !important;
  }

  body:has(.hp-page) .hp-page .case-image {
    height: 180px !important;
  }

  body:has(.hp-page) .hp-page .case-image .case-image-effect {
    width: 124% !important;
    height: 124% !important;
    max-width: 220px !important;
    max-height: 220px !important;
  }

  body:has(.hp-page) .hp-page .case-image .case-image-main {
    width: 90% !important;
    height: 90% !important;
    max-width: 166px !important;
    max-height: 166px !important;
  }
}
</style>
